// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__13tMl","perdeu":"LoginForm_perdeu__zSihY","cadastro":"LoginForm_cadastro__1-1Wy","subtitle":"LoginForm_subtitle__MKIPG"};